<template>
  <div style="padding-bottom: 20%">
    <van-sticky>
      <van-dropdown-menu>
        <van-dropdown-item :title="categoryTitle" ref="categoryselect">
          <van-cell center @click="selectCategory(null)" :title="allCategoryTitle" />
          <van-cell v-for="c in rootCategorys" :key="c.value" center @click="selectCategory(c.value)" :title="c.label" />
        </van-dropdown-item>
      </van-dropdown-menu>
      <van-search
        v-model="listQuery.name"
        :show-action="true"
        :clearable="false"
        :action-text="$t('common.clear')"
        :placeholder="$t('product.name')"
        input-align="center"
        @search="refreshProducts"
        @cancel="clearSearch"
      />
    </van-sticky>
    <van-pull-refresh v-model="pullRefreshing" @refresh="refreshProducts">
      <van-list
        v-model="listLoading"
        :finished="listFinished"
        :finished-text="$t('common.noMore')"
        :immediate-check="false"
        @load="onLoad"
      >
        <van-card
          v-for="product in products"
          :key="product.id"
          :num="product.stock"
          :price="product.price.toFixed(2)"
          :title="product.name"
          :thumb="product.picUrl"
          currency="S/."
          @click="showProduct(product.id)">
          <template #desc>
            <div class="product-des" v-html="'['+product.brandName+'] '+product.productInfo"></div>
          </template>
        </van-card>
      </van-list>
    </van-pull-refresh>

    <van-sku
      v-model="showItem"
      :sku="sku"
      :initial-sku="initialSku"
      :goods="goods"
      :hide-stock="sku.hide_stock"
      :show-add-cart-btn="false"
      :buy-text="$t('product.addToCart')"
      @buy-clicked="buySku">
      <template #sku-header-price="props">
        <div class="van-sku__goods-price">
          <span class="van-sku__price-symbol">S/.</span>
          <span class="van-sku__price-num">{{ props.price }}</span>
        </div>
      </template>
      <template #sku-body-top>
        <div class="product-all-des" v-html="selectedProductDes"></div>
      </template>
      <template #sku-stepper="props">
        <div class="van-sku-stepper-stock">
          <div class="van-sku__stepper-title">{{ $t('product.buyCount') }}</div>
          <div class="van-sku__stepper">
            <van-stepper v-model="selectedNum" min="1" :max="props.selectedSkuComb?props.selectedSkuComb.stock_num:1" />
          </div>
        </div>
      </template>
    </van-sku>
  </div>
</template>

<script>
import i18n from '@/i18n'
import { Toast } from 'vant'
import { getAllCategory, listProducts, getProductInfo } from '@/api/product'
import { addProductToShoppingcart } from '@/api/shoppingcart'

export default {
  data() {
    return {
      categoryTitle: i18n.t('product.category'),
      allCategoryTitle: i18n.t('product.all'),
      rootCategorys: [],
      listQuery: {
        categoryId: '',
        name: '',
        supplierId: window.location.hostname == 'k.starpay.pe' ? process.env.VUE_APP_KSUPPLIERID : window.location.hostname == 'ruyu.g.starpay.pe' ? process.env.VUE_APP_PSUPPLIERID : window.location.hostname == 'decor.g.starpay.pe' ? process.env.VUE_APP_DSUPPLIERID : window.location.hostname == 'prow.g.starpay.pe' ? process.env.VUE_APP_WSUPPLIERID : window.location.hostname == 'mchome.g.starpay.pe' ? process.env.VUE_APP_MSUPPLIERID : process.env.VUE_APP_GSUPPLIERID, // StarPay自营店id
        page: 1
      },
      pullRefreshing: false,
      listLoading: false,
      listFinished: true,
      products: [],
      showItem: false,
      sku: {
        tree: [{
          k: i18n.t('product.spec'),
          k_s: 'spec',
          v: []
        }, {
          k: i18n.t('product.unit'),
          k_s: 'unit',
          v: []
        }],
        list: [],
        stock_num: 0
      },
      selectedNum: 1,
      initialSku: {},
      goods: {},
      selectedProductDes: ''
    }
  },
  created() {
    this.fetchAllCategory()
    this.fetchProducts()
  },
  methods: {
    fetchAllCategory() {
      getAllCategory({ supplierId: this.listQuery.supplierId }).then(rep => {
        let allCount = 0
        rep.data.forEach(rootCategory => {
          if (rootCategory.productsCount > 0) {
            allCount += rootCategory.productsCount
            this.rootCategorys.push(rootCategory)
          }
        })
        this.allCategoryTitle += '(' + allCount + ')'
      })
    },
    fetchProducts() {
      this.listLoading = true
      this.listFinished = false
      listProducts(this.listQuery).then(rep => {
        this.products.push(...rep.data.products)
        this.pullRefreshing = false
        this.listLoading = false
        if (rep.data.products.length == 0) {
          this.listFinished = true
        }
      }).catch(() => {})
    },
    clearSearch() {
      this.listQuery.name = ''
      this.products = []
      this.listQuery.page = 1
      this.fetchProducts()
    },
    selectCategory(categoryId) {
      if (categoryId) {
        let thirdCategoryIds = []
        this.rootCategorys.forEach(rc => {
          if (rc.value == categoryId) {
            this.categoryTitle = rc.label
            rc.children.forEach(sc => {
              sc.children.forEach(tc => {
                thirdCategoryIds.push(tc.value)
              })
            })
          }
        })
        this.listQuery.categoryId = thirdCategoryIds
      } else {
        this.categoryTitle = this.allCategoryTitle
        this.listQuery.categoryId = ''
      }
      this.$refs.categoryselect.toggle()
      this.refreshProducts()
    },
    refreshProducts() {
      this.products = []
      this.listQuery.page = 1
      this.fetchProducts()
    },
    onLoad() {
      this.listQuery.page++
      this.fetchProducts()
    },
    showProduct(productId) {
      getProductInfo({ productId: productId }).then(rep => {
        this.selectedProductDes = '[' + rep.data.brand + '] ' + rep.data.productInfo
        this.goods = {
          picture: rep.data.mainPic
        }
        this.initialSku = {}
        // 规格
        this.sku.tree[0].v = []
        // 销售单位
        this.sku.tree[1].v = []
        // 框架里需要的串联结构
        this.sku.list = []
        this.sku.stock_num = 0
        rep.data.specs.forEach(spec => {
          this.sku.tree[0].v.push({
            id: spec.id,
            name: spec.name,
            imgUrl: spec.pic,
            previewImgUrl: spec.pic
          })
          this.sku.stock_num += parseInt(spec.stock)
          spec.sellUnits.forEach(su => {
            let hasSellUnit = false
            let skuTreeVId
            let tempSellUnitName = su.name + (su.specStockCount > 1 ? '(' + su.specStockCount + spec.stockUnit + ')' : '')
            // 销售单位添加到规格树中，避免名称重复
            for (let i = 0; i < this.sku.tree[1].v.length; i ++) {
              if (this.sku.tree[1].v[i].name == tempSellUnitName) {
                hasSellUnit = true
                skuTreeVId = this.sku.tree[1].v[i].id
                break
              }
            }
            if (!hasSellUnit) {
              this.sku.tree[1].v.push({
                id: su.id,
                name: tempSellUnitName,
              })
              skuTreeVId = su.id
            }
            this.sku.list.push({
              id: su.id,
              spec: spec.id,
              unit: skuTreeVId,
              price: parseFloat((su.price * 100).toFixed(1)),
              stock_num: Math.floor(spec.stock / su.specStockCount)
            })
          })
        })
        if (this.sku.list.length == 1) {
          this.initialSku = {
            spec: this.sku.list[0].specs,
            unit: this.sku.list[0].unit
          }
        }
        console.log(this.sku.list)
        this.showItem = true
      })
    },
    buySku(skuData) {
      if (skuData.selectedSkuComb && skuData.selectedSkuComb.id) {
        addProductToShoppingcart({ sellUnitId: skuData.selectedSkuComb.id, buyCount: this.selectedNum }).then(rep => {
          Toast.success(i18n.t('product.addedToCartTip'))
          this.$parent.fetchCartProductCount()
        })
      } else {
        Toast.fail(i18n.t('product.selectSpecTip'))
      }
    }
  }
}
</script>

<style scoped>
.product-des {
  max-height: 60px;
  overflow: hidden;
  line-height: 20px;
  color: #646566;
  word-wrap: break-word;
  text-overflow: ellipsis;
  font-size: 12px;
  text-align: left;
}
.product-all-des {
  line-height: 20px;
  color: #646566;
  font-size: 12px;
  text-align: left;
  padding: 0 15px;
}
</style>